import { render, staticRenderFns } from "./ProgramReview.vue?vue&type=template&id=a96f4ae8"
import script from "./ProgramReview.vue?vue&type=script&lang=js"
export * from "./ProgramReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports